import React from "react";
import { Redirect, useParams, useLocation } from "react-router-dom";

import AboutUs from "../screens/AboutUs";
import Cart from "../screens/Cart";
import Contact from "../screens/Contact";
import EndSubscription from "../screens/EndSubscription";
import FAQPage from "../screens/FAQ";
import ForCompanies from "../screens/ForCompanies";
import Health from "../screens/Health";
import Login from "../screens/Login";
import MemoryGame from "../screens/memoryGame/MemoryGame";
import Osta from "../screens/osta/Osta";
import PaymentMethod from "../screens/PaymentMethod";
import Phone from "../screens/phone/Phone";
import PlaceOrder from "../screens/PlaceOrder";
import PrivacyPolicy from "../screens/PrivacyPolicy";
import Register from "../screens/Register";
import Services from "../screens/Services";
import Shipping from "../screens/Shipping";
import TermsOfUse from "../screens/TermsOfUse";
import Thanks from "../screens/thanks/Thanks";
import VideoCallApp from "../screens/videoCallApp/videoCallApp";
import Watch from "../screens/watch/Watch";
import { getLocaleFromPath, getRouteKeyFromSlug } from "./config";

const componentRegistry: Record<string, React.ComponentType<any>> = {
    osta: Osta,
    senioritabletti: Services,
    senioripuhelin: Phone,
    turvaranneke: Watch,
    videopuhelu_appi: VideoCallApp,
    muistipeli: MemoryGame,
    usein_kysyttya: FAQPage,
    yhteydenotto: Contact,
    yrityksille: ForCompanies,
    happysenior_blogi: Health,
    aboutus: AboutUs,
    palveluehdot: TermsOfUse,
    copyright: PrivacyPolicy,
    ostoskori: Cart,
    toimitus: Shipping,
    maksutapa: PaymentMethod,
    tee_tilaus: PlaceOrder,
    thanks: Thanks,
    kirjaudu: Login,
    luo_tili: Register,
    subscription_end: EndSubscription,
};

/** Single-slug catch-all: /:slug → component */
const LocalizedRoute: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const { pathname } = useLocation();
    const lang = getLocaleFromPath(pathname);
    const routeKey = getRouteKeyFromSlug(slug, lang)
        || getRouteKeyFromSlug(slug, "fi")
        || getRouteKeyFromSlug(slug, "en")
        || getRouteKeyFromSlug(slug, "sv");

    if (!routeKey) return <Redirect to="/" />;

    const Component = componentRegistry[routeKey];
    if (!Component) return <Redirect to="/" />;

    return <Component />;
};

export default LocalizedRoute;
